import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59ec2985&"
import script from "./zPayDeleteCardConfirmModal.js?vue&type=script&lang=js&"
export * from "./zPayDeleteCardConfirmModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports